import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { AUTH_DETAILS, AUTH_TOKEN, MENU_ITEMS } from 'constants/AuthConstant';
import { useDispatch } from 'react-redux';
import masterService from 'services/MasterService';
import OrderService from 'services/OrderService';



export const initialState = {
    loading: false,
    message: '',
    list: null,
    sublist: null,
    subloading: false
}

export const salesStageListAll = createAsyncThunk('/salestage/list', async (data, { rejectWithValue }) => {

    try {
        const response = await OrderService.getSaleStage(data)
        return response.data;
    } catch (err) {
        return rejectWithValue(err.response?.data?.message || 'Error')
    }
})

export const salesStageSlice = createSlice({
    name: 'salesStage',
    initialState,
    reducers: {

        salesStageList: (state, action) => {
            state.loading = true
            state.list = action.payload
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(salesStageListAll.pending, (state) => {

                state.loading = false
            })
            .addCase(salesStageListAll.fulfilled, (state, action) => {
                state.loading = true
                state.list = action.payload
            })
    },
})

export const {
    salesStageList
} = salesStageSlice.actions

export default salesStageSlice.reducer